import { jsx, jsxs } from 'react/jsx-runtime';
import { forwardRef } from 'react';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$a =
  // eslint-disable-next-line es-x/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$9 = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$8 = fails$9;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$8(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var fails$7 = fails$9;

var functionBindNative = !fails$7(function () {
  // eslint-disable-next-line es-x/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$1 = functionBindNative;

var call$5 = Function.prototype.call;

var functionCall = NATIVE_BIND$1 ? call$5.bind(call$5) : function () {
  return call$5.apply(call$5, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$1 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$1(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$2 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var NATIVE_BIND = functionBindNative;

var FunctionPrototype$1 = Function.prototype;
var bind = FunctionPrototype$1.bind;
var call$4 = FunctionPrototype$1.call;
var uncurryThis$a = NATIVE_BIND && bind.bind(call$4, call$4);

var functionUncurryThis = NATIVE_BIND ? function (fn) {
  return fn && uncurryThis$a(fn);
} : function (fn) {
  return fn && function () {
    return call$4.apply(fn, arguments);
  };
};

var uncurryThis$9 = functionUncurryThis;

var toString$1 = uncurryThis$9({}.toString);
var stringSlice = uncurryThis$9(''.slice);

var classofRaw = function (it) {
  return stringSlice(toString$1(it), 8, -1);
};

var uncurryThis$8 = functionUncurryThis;
var fails$6 = fails$9;
var classof = classofRaw;

var $Object$2 = Object;
var split = uncurryThis$8(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$6(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$2('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split(it, '') : $Object$2(it);
} : $Object$2;

var $TypeError$5 = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$2 = function (it) {
  if (it == undefined) throw $TypeError$5("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$1 = indexedObject;
var requireObjectCoercible$1 = requireObjectCoercible$2;

var toIndexedObject$3 = function (it) {
  return IndexedObject$1(requireObjectCoercible$1(it));
};

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$a = function (argument) {
  return typeof argument == 'function';
};

var isCallable$9 = isCallable$a;

var isObject$5 = function (it) {
  return typeof it == 'object' ? it !== null : isCallable$9(it);
};

var global$9 = global$a;
var isCallable$8 = isCallable$a;

var aFunction = function (argument) {
  return isCallable$8(argument) ? argument : undefined;
};

var getBuiltIn$3 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$9[namespace]) : global$9[namespace] && global$9[namespace][method];
};

var uncurryThis$7 = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$7({}.isPrototypeOf);

var getBuiltIn$2 = getBuiltIn$3;

var engineUserAgent = getBuiltIn$2('navigator', 'userAgent') || '';

var global$8 = global$a;
var userAgent = engineUserAgent;

var process = global$8.process;
var Deno = global$8.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es-x/no-symbol -- required for testing */

var V8_VERSION = engineV8Version;
var fails$5 = fails$9;

// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- required for testing
var nativeSymbol = !!Object.getOwnPropertySymbols && !fails$5(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

/* eslint-disable es-x/no-symbol -- required for testing */

var NATIVE_SYMBOL$1 = nativeSymbol;

var useSymbolAsUid = NATIVE_SYMBOL$1
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var getBuiltIn$1 = getBuiltIn$3;
var isCallable$7 = isCallable$a;
var isPrototypeOf = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var $Object$1 = Object;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$1('Symbol');
  return isCallable$7($Symbol) && isPrototypeOf($Symbol.prototype, $Object$1(it));
};

var $String$1 = String;

var tryToString$1 = function (argument) {
  try {
    return $String$1(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$6 = isCallable$a;
var tryToString = tryToString$1;

var $TypeError$4 = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$1 = function (argument) {
  if (isCallable$6(argument)) return argument;
  throw $TypeError$4(tryToString(argument) + ' is not a function');
};

var aCallable = aCallable$1;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$1 = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable(func);
};

var call$3 = functionCall;
var isCallable$5 = isCallable$a;
var isObject$4 = isObject$5;

var $TypeError$3 = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$5(fn = input.toString) && !isObject$4(val = call$3(fn, input))) return val;
  if (isCallable$5(fn = input.valueOf) && !isObject$4(val = call$3(fn, input))) return val;
  if (pref !== 'string' && isCallable$5(fn = input.toString) && !isObject$4(val = call$3(fn, input))) return val;
  throw $TypeError$3("Can't convert object to primitive value");
};

var shared$3 = {exports: {}};

var global$7 = global$a;

// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var defineProperty$2 = Object.defineProperty;

var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$2(global$7, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$7[key] = value;
  } return value;
};

var global$6 = global$a;
var defineGlobalProperty$2 = defineGlobalProperty$3;

var SHARED = '__core-js_shared__';
var store$3 = global$6[SHARED] || defineGlobalProperty$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$3.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.22.8',
  mode: 'global',
  copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.22.8/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var requireObjectCoercible = requireObjectCoercible$2;

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$2 = function (argument) {
  return $Object(requireObjectCoercible(argument));
};

var uncurryThis$6 = functionUncurryThis;
var toObject$1 = toObject$2;

var hasOwnProperty = uncurryThis$6({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es-x/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$1(it), key);
};

var uncurryThis$5 = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString = uncurryThis$5(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};

var global$5 = global$a;
var shared$2 = shared$3.exports;
var hasOwn$6 = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL = nativeSymbol;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var WellKnownSymbolsStore = shared$2('wks');
var Symbol$1 = global$5.Symbol;
var symbolFor = Symbol$1 && Symbol$1['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;

var wellKnownSymbol$1 = function (name) {
  if (!hasOwn$6(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL && hasOwn$6(Symbol$1, name)) {
      WellKnownSymbolsStore[name] = Symbol$1[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};

var call$2 = functionCall;
var isObject$3 = isObject$5;
var isSymbol$1 = isSymbol$2;
var getMethod = getMethod$1;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol = wellKnownSymbol$1;

var $TypeError$2 = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$3(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$2(exoticToPrim, input, pref);
    if (!isObject$3(result) || isSymbol$1(result)) return result;
    throw $TypeError$2("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var global$4 = global$a;
var isObject$2 = isObject$5;

var document = global$4.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$2(document) && isObject$2(document.createElement);

var documentCreateElement = function (it) {
  return EXISTS$1 ? document.createElement(it) : {};
};

var DESCRIPTORS$7 = descriptors;
var fails$4 = fails$9;
var createElement = documentCreateElement;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$7 && !fails$4(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var DESCRIPTORS$6 = descriptors;
var call$1 = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$1 = createPropertyDescriptor$2;
var toIndexedObject$2 = toIndexedObject$3;
var toPropertyKey$1 = toPropertyKey$2;
var hasOwn$5 = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$6 ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$2(O);
  P = toPropertyKey$1(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$5(O, P)) return createPropertyDescriptor$1(!call$1(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var objectDefineProperty = {};

var DESCRIPTORS$5 = descriptors;
var fails$3 = fails$9;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$5 && fails$3(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});

var isObject$1 = isObject$5;

var $String = String;
var $TypeError$1 = TypeError;

// `Assert: Type(argument) is Object`
var anObject$2 = function (argument) {
  if (isObject$1(argument)) return argument;
  throw $TypeError$1($String(argument) + ' is not an object');
};

var DESCRIPTORS$4 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var anObject$1 = anObject$2;
var toPropertyKey = toPropertyKey$2;

var $TypeError = TypeError;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$4 ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject$1(O);
  P = toPropertyKey(P);
  anObject$1(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$1(O);
  P = toPropertyKey(P);
  anObject$1(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$3 = descriptors;
var definePropertyModule$1 = objectDefineProperty;
var createPropertyDescriptor = createPropertyDescriptor$2;

var createNonEnumerableProperty$3 = DESCRIPTORS$3 ? function (object, key, value) {
  return definePropertyModule$1.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var makeBuiltIn$2 = {exports: {}};

var DESCRIPTORS$2 = descriptors;
var hasOwn$4 = hasOwnProperty_1;

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$2 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$4(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$2 || (DESCRIPTORS$2 && getDescriptor(FunctionPrototype, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$4 = functionUncurryThis;
var isCallable$4 = isCallable$a;
var store$1 = sharedStore;

var functionToString = uncurryThis$4(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$4(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$2 = store$1.inspectSource;

var global$3 = global$a;
var isCallable$3 = isCallable$a;
var inspectSource$1 = inspectSource$2;

var WeakMap$1 = global$3.WeakMap;

var nativeWeakMap = isCallable$3(WeakMap$1) && /native code/.test(inspectSource$1(WeakMap$1));

var shared$1 = shared$3.exports;
var uid = uid$2;

var keys = shared$1('keys');

var sharedKey$1 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys$3 = {};

var NATIVE_WEAK_MAP = nativeWeakMap;
var global$2 = global$a;
var uncurryThis$3 = functionUncurryThis;
var isObject = isObject$5;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$3;
var hasOwn$3 = hasOwnProperty_1;
var shared = sharedStore;
var sharedKey = sharedKey$1;
var hiddenKeys$2 = hiddenKeys$3;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$1 = global$2.TypeError;
var WeakMap = global$2.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError$1('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = uncurryThis$3(store.get);
  var wmhas = uncurryThis$3(store.has);
  var wmset = uncurryThis$3(store.set);
  set = function (it, metadata) {
    if (wmhas(store, it)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget(store, it) || {};
  };
  has = function (it) {
    return wmhas(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys$2[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn$3(it, STATE)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$2(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$3(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$3(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var fails$2 = fails$9;
var isCallable$2 = isCallable$a;
var hasOwn$2 = hasOwnProperty_1;
var DESCRIPTORS$1 = descriptors;
var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;
var inspectSource = inspectSource$2;
var InternalStateModule = internalState;

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var defineProperty$1 = Object.defineProperty;

var CONFIGURABLE_LENGTH = DESCRIPTORS$1 && !fails$2(function () {
  return defineProperty$1(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$1 = makeBuiltIn$2.exports = function (value, name, options) {
  if (String(name).slice(0, 7) === 'Symbol(') {
    name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$2(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    defineProperty$1(value, 'name', { value: name, configurable: true });
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$2(options, 'arity') && value.length !== options.arity) {
    defineProperty$1(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$2(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$1) defineProperty$1(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn$2(state, 'source')) {
    state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$1(function toString() {
  return isCallable$2(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');

var isCallable$1 = isCallable$a;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$3;
var makeBuiltIn = makeBuiltIn$2.exports;
var defineGlobalProperty$1 = defineGlobalProperty$3;

var defineBuiltIn$1 = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$1(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    if (!options.unsafe) delete O[key];
    else if (O[key]) simple = true;
    if (simple) O[key] = value;
    else createNonEnumerableProperty$1(O, key, value);
  } return O;
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es-x/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$2 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$1 = toIntegerOrInfinity$2;

var max = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$1(index);
  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};

var toIntegerOrInfinity = toIntegerOrInfinity$2;

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$1 = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength = toLength$1;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$1 = function (obj) {
  return toLength(obj.length);
};

var toIndexedObject$1 = toIndexedObject$3;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike = lengthOfArrayLike$1;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$1($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

var uncurryThis$2 = functionUncurryThis;
var hasOwn$1 = hasOwnProperty_1;
var toIndexedObject = toIndexedObject$3;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$1 = hiddenKeys$3;

var push = uncurryThis$2([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$1(hiddenKeys$1, key) && hasOwn$1(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$1(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$2 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$2;

var hiddenKeys = enumBugKeys$1.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es-x/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn = getBuiltIn$3;
var uncurryThis$1 = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject = anObject$2;

var concat$1 = uncurryThis$1([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$1(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule = objectDefineProperty;

var copyConstructorProperties$1 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$1 = fails$9;
var isCallable = isCallable$a;

var replacement = /#|\.prototype\./;

var isForced$1 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails$1(detection)
    : !!detection;
};

var normalize = isForced$1.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$1.data = {};
var NATIVE = isForced$1.NATIVE = 'N';
var POLYFILL = isForced$1.POLYFILL = 'P';

var isForced_1 = isForced$1;

var global$1 = global$a;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty = createNonEnumerableProperty$3;
var defineBuiltIn = defineBuiltIn$1;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties = copyConstructorProperties$1;
var isForced = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$1;
  } else if (STATIC) {
    target = global$1[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global$1[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys = enumBugKeys$2;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es-x/no-object-keys -- safe
var objectKeys$1 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};

var DESCRIPTORS = descriptors;
var uncurryThis = functionUncurryThis;
var call = functionCall;
var fails = fails$9;
var objectKeys = objectKeys$1;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject = toObject$2;
var IndexedObject = indexedObject;

// eslint-disable-next-line es-x/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;
var concat = uncurryThis([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es-x/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $ = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es-x/no-object-assign -- required for testing
$({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

const Icon = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  const {
    children
  } = props,
        remainingProps = __rest(props, ["children"]);

  return jsx("svg", Object.assign({
    ref: forwardedRef,
    role: 'img',
    width: 22,
    height: 22,
    "aria-hidden": 'true',
    fill: 'currentColor',
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 22 22'
  }, remainingProps, {
    children: children
  }));
});

const AustriaFlag = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  return jsxs(Icon, Object.assign({
    ref: forwardedRef
  }, props, {
    children: [jsx("path", {
      d: 'M21.3714 7.33228H14.5939C14.8881 9.68206 14.89 12.2712 14.5995 14.6239H21.3858C21.7818 13.4889 21.9998 12.27 21.9998 11C21.9999 9.71327 21.7771 8.47942 21.3714 7.33228Z',
      fill: '#E4E4E4'
    }), jsx("path", {
      d: 'M14.5938 7.33246H21.3712C21.37 7.32897 21.3689 7.32605 21.3677 7.32289C19.9599 3.35334 16.3388 0.432841 11.9881 0.045166C13.6715 0.968118 14.1632 3.89229 14.5938 7.33246Z',
      fill: '#D32027'
    }), jsx("path", {
      d: 'M11.9881 21.9544C16.3468 21.566 19.9732 18.6354 21.3755 14.6553C21.3792 14.6447 21.3823 14.6342 21.3861 14.624H14.5996C14.1724 18.0828 13.6787 21.0276 11.9881 21.9544Z',
      fill: '#D32027'
    }), jsx("path", {
      d: 'M4.57764e-05 11C4.57764e-05 12.2702 0.218012 13.4889 0.614001 14.6239H15.1658C15.4563 12.271 15.4544 9.68206 15.1602 7.33228H0.628584C0.222842 8.47946 4.57764e-05 9.71332 4.57764e-05 11Z',
      fill: '#F3F4F5'
    }), jsx("path", {
      d: 'M0.632054 7.32287C0.630846 7.32598 0.629778 7.32895 0.628571 7.33244H15.1602C14.7296 3.89226 13.6715 0.968143 11.9879 0.0451908C11.6622 0.0163486 11.3329 0 10.9998 0C6.21463 0 2.14518 3.05616 0.632054 7.32287Z',
      fill: '#DB2727'
    }), jsx("path", {
      d: 'M15.1658 14.624H0.614029C0.617698 14.6343 0.620996 14.6447 0.624618 14.6553C2.13185 18.9329 6.20683 21.9998 10.9998 21.9998C11.3329 21.9998 11.6622 21.9835 11.9879 21.9543C13.6787 21.0276 14.7387 18.0828 15.1658 14.624Z',
      fill: '#DB2727'
    })]
  }));
});

const GermanyFlag = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  return jsxs(Icon, Object.assign({
    ref: forwardedRef
  }, props, {
    children: [jsx("path", {
      d: 'M21.3712 7.33252H14.5938C14.8881 9.68228 14.89 12.2714 14.5994 14.6241H21.3857C21.7817 13.4891 21.9997 12.2702 21.9997 11.0002C21.9999 9.7135 21.7769 8.47965 21.3712 7.33252Z',
      fill: '#D32027'
    }), jsx("path", {
      d: 'M14.5938 7.3327H21.3711C21.3699 7.32922 21.3688 7.32629 21.3676 7.32313C19.9597 3.35358 16.3386 0.433085 11.9876 0.0454102C13.6713 0.968362 14.163 3.89253 14.5938 7.3327Z',
      fill: '#0B0B0B'
    }), jsx("path", {
      d: 'M11.9878 21.9545C16.3466 21.5661 19.9729 18.6355 21.3752 14.6553C21.3789 14.6447 21.382 14.6343 21.3858 14.624H14.5993C14.1722 18.0828 13.6784 21.0277 11.9878 21.9545Z',
      fill: '#F3C515'
    }), jsx("path", {
      d: 'M0 11.0002C0 12.2704 0.217966 13.4891 0.613955 14.6241H15.1657C15.4563 12.2712 15.4544 9.6823 15.1602 7.33252H0.628585C0.222842 8.47971 0 9.71356 0 11.0002Z',
      fill: '#DB2727'
    }), jsx("path", {
      d: 'M0.631857 7.32287C0.63065 7.32598 0.629582 7.32895 0.628374 7.33244H15.1601C14.7294 3.89226 13.6713 0.968143 11.9878 0.0451908C11.6621 0.0163486 11.3328 0 10.9997 0C6.21455 0 2.14498 3.05616 0.631857 7.32287Z',
      fill: '#151515'
    }), jsx("path", {
      d: 'M15.1657 14.624H0.613976C0.617645 14.6343 0.620942 14.6447 0.624565 14.6553C2.13179 18.933 6.20675 22 10.9997 22C11.3329 22 11.6621 21.9836 11.9878 21.9544C13.6785 21.0277 14.7386 18.0828 15.1657 14.624Z',
      fill: '#F8D12E'
    })]
  }));
});

const UnitedKingdomFlag = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  return jsxs(Icon, Object.assign({
    ref: forwardedRef
  }, props, {
    children: [jsx("path", {
      d: 'M1.93737 4.76709C1.22802 5.79667 0.688938 6.95272 0.362061 8.19525H5.36574L1.93737 4.76709Z',
      fill: '#29337A'
    }), jsx("path", {
      d: 'M7.9194 0.44043C6.65202 0.809527 5.47828 1.39849 4.4447 2.16669L7.9194 5.64142V0.44043Z',
      fill: '#29337A'
    }), jsx("path", {
      d: 'M4.70312 20.0171C5.67262 20.6956 6.75578 21.2208 7.91946 21.5597V16.8013L4.70312 20.0171Z',
      fill: '#29337A'
    }), jsx("path", {
      d: 'M0.488281 14.248C0.851991 15.4262 1.40933 16.5192 2.12161 17.4914L5.36499 14.248H0.488281V14.248Z',
      fill: '#29337A'
    }), jsx("path", {
      d: 'M2.11878 4.51221C2.05729 4.59627 1.99668 4.68154 1.93727 4.7677L5.36564 8.19589H0.361959C0.280866 8.50451 0.214682 8.81908 0.160156 9.13797H6.74491L2.11878 4.51221Z',
      fill: 'white'
    }), jsx("path", {
      d: 'M4.44788 19.8357C4.53157 19.8981 4.61759 19.9575 4.703 20.0172L7.9193 16.8013V21.5596C8.2283 21.6499 8.54213 21.7279 8.86139 21.7906V15.4224L4.44788 19.8357Z',
      fill: 'white'
    }), jsx("path", {
      d: 'M0.243896 13.3062C0.31217 13.6254 0.392752 13.9398 0.488104 14.2482H5.36486L2.12148 17.4916C2.47422 17.9736 2.86538 18.4259 3.2904 18.8441L8.8283 13.3062H0.243896Z',
      fill: 'white'
    }), jsx("path", {
      d: 'M7.91938 0.440489V5.64148L4.4446 2.16694C3.96557 2.52317 3.5178 2.91865 3.10291 3.34678L8.86128 9.10515V0.209473C8.5422 0.272545 8.22837 0.350711 7.91938 0.440489Z',
      fill: 'white'
    }), jsx("path", {
      d: 'M7.91938 14.2148L7.88635 14.2481H7.91938V14.2148Z',
      fill: '#D32030'
    }), jsx("path", {
      d: 'M8.82837 13.306H8.86135V13.2729L8.82837 13.306Z',
      fill: '#D32030'
    }), jsx("path", {
      d: 'M13.0617 9.1377H13.0299V9.16965L13.0617 9.1377Z',
      fill: '#D32030'
    }), jsx("path", {
      d: 'M7.9519 8.19574L7.91943 8.16309V8.19574H7.9519Z',
      fill: '#D32030'
    }), jsx("path", {
      d: 'M8.86145 9.10547V9.13798H8.89396L8.86145 9.10547Z',
      fill: '#D32030'
    }), jsx("path", {
      d: 'M13.9717 19.1241V21.5899C15.1505 21.2599 16.2496 20.7397 17.2326 20.062L14.5608 17.3901C14.3473 18.1403 14.2692 18.5281 13.9717 19.1241Z',
      fill: '#252F6C'
    }), jsx("path", {
      d: 'M14.5749 5.03755L17.4916 2.12086C16.4438 1.3535 15.255 0.768709 13.9717 0.40918V2.94219C14.3147 3.62911 14.3436 4.15106 14.5749 5.03755Z',
      fill: '#252F6C'
    }), jsx("path", {
      d: 'M19.8332 17.555C20.5678 16.5669 21.1402 15.4516 21.5121 14.2476H16.5258L19.8332 17.555Z',
      fill: '#252F6C'
    }), jsx("path", {
      d: 'M21.638 8.19538C21.3042 6.92661 20.7489 5.74887 20.0172 4.70312L16.5245 8.19538H21.638Z',
      fill: '#252F6C'
    }), jsx("path", {
      d: 'M15.217 13.4924L15.9729 14.2482L19.5911 17.8664C19.6733 17.7636 19.7549 17.6612 19.8334 17.5557L16.5259 14.2482H21.5123C21.6073 13.9399 21.688 13.6254 21.7561 13.3062H15.2877C15.2771 13.4397 15.2297 13.3597 15.217 13.4924Z',
      fill: '#E7E7E7'
    }), jsx("path", {
      d: 'M14.4606 5.58941L17.74 2.30971C17.6578 2.24598 17.5755 2.18259 17.4916 2.12109L14.5749 5.03778C14.6051 5.15311 14.4325 5.4713 14.4606 5.58941Z',
      fill: '#E7E7E7'
    }), jsx("path", {
      d: 'M13.9717 2.74V0.409486C13.6631 0.323006 13.3489 0.249716 13.0297 0.189941V1.32673C13.3802 1.70674 13.6944 2.18405 13.9717 2.74Z',
      fill: '#E7E7E7'
    }), jsx("path", {
      d: 'M15.1429 9.13782H21.8401C21.7857 8.81893 21.7193 8.50454 21.6383 8.19573H16.5248L20.0174 4.70345C19.6741 4.21294 19.2925 3.75165 18.8756 3.32422L14.9417 7.25782C15.0476 7.97135 15.095 8.38573 15.1429 9.13782Z',
      fill: '#E7E7E7'
    }), jsx("path", {
      d: 'M14.402 17.2313L17.2329 20.0625C17.7037 19.7383 18.1471 19.3773 18.5609 18.9855L14.8373 15.2617C14.7184 15.9504 14.5774 16.6156 14.402 17.2313Z',
      fill: '#E7E7E7'
    }), jsx("path", {
      d: 'M13.0299 20.5428V21.8099C13.3491 21.7505 13.6632 21.6768 13.972 21.5903V19.1245C13.6944 19.6807 13.3802 20.1633 13.0299 20.5428Z',
      fill: '#E7E7E7'
    }), jsx("path", {
      d: 'M14.9416 7.25764L18.8752 3.32404C18.5211 2.96033 18.1414 2.62184 17.7398 2.31006L14.6489 5.40148C14.7863 5.97567 14.8487 6.63291 14.9416 7.25764Z',
      fill: '#D71F28'
    }), jsx("path", {
      d: 'M10.451 0.0135619C10.6343 0.00469093 10.817 0 10.9999 0C10.816 0 10.6329 0.00469093 10.451 0.0135619Z',
      fill: '#D32030'
    }), jsx("path", {
      d: 'M10.9999 22.0002C10.817 22.0002 10.6343 21.9952 10.4514 21.9863C10.6333 21.9955 10.816 22.0002 10.9999 22.0002Z',
      fill: '#D32030'
    }), jsx("path", {
      d: 'M10.9999 22.0004C11.6939 22.0004 12.3716 21.9332 13.0299 21.81V20.543C12.4521 21.1693 11.7761 22.0004 10.9999 22.0004Z',
      fill: '#D32030'
    }), jsx("path", {
      d: 'M21.8397 9.13721H15.2296C15.3172 10.5168 15.3066 11.9355 15.198 13.3056H21.756C21.9148 12.5617 21.9999 11.7909 21.9999 11C21.9999 10.3646 21.9432 9.74317 21.8397 9.13721Z',
      fill: '#D71F28'
    }), jsx("path", {
      d: 'M15.217 13.4922C15.1559 14.1421 14.943 14.6486 14.837 15.2617L18.5607 18.9853C18.9291 18.6362 19.2735 18.2628 19.591 17.8663L15.9729 14.2479L15.217 13.4922Z',
      fill: '#D71F28'
    }), jsx("path", {
      d: 'M13.0299 1.40839V0.190006C12.3719 0.0672057 11.6941 0 10.9999 0C11.7761 0 12.4521 0.782271 13.0299 1.40839Z',
      fill: '#D32030'
    }), jsx("path", {
      d: 'M13.9718 19.5999C14.2693 19.0038 14.5244 18.3176 14.7381 17.5676L13.9718 16.8013V19.5999Z',
      fill: '#29337A'
    }), jsx("path", {
      d: 'M14.8335 4.77923C14.6017 3.89273 14.3148 3.08682 13.9718 2.3999V5.6405L14.8335 4.77923Z',
      fill: '#29337A'
    }), jsx("path", {
      d: 'M15.4305 13.7059C15.443 13.5732 15.4543 13.44 15.4651 13.3062H15.0309L15.4305 13.7059Z',
      fill: 'white'
    }), jsx("path", {
      d: 'M13.9717 5.64087V2.40009C13.6942 1.84414 13.3802 1.3665 13.0297 0.986816V7.02028L14.9216 5.12835C14.8931 5.01024 14.8632 4.89455 14.8333 4.77922L13.9717 5.64087Z',
      fill: 'white'
    }), jsx("path", {
      d: 'M13.0615 9.13742H15.4966C15.4488 8.38539 15.3728 7.64548 15.267 6.93213L13.0615 9.13742Z',
      fill: 'white'
    }), jsx("path", {
      d: 'M13.0299 21.0135C13.3804 20.6335 13.6944 20.1562 13.972 19.6003V16.8017L14.7383 17.568C14.914 16.9519 15.0615 16.2938 15.1807 15.6052L13.03 13.4546L13.0299 21.0135Z',
      fill: 'white'
    }), jsx("path", {
      d: 'M13.0299 21.0131V13.4542L15.1805 15.6049C15.2862 14.9916 15.3694 14.3556 15.4304 13.7055L15.0307 13.3058H15.4649C15.5735 11.9356 15.5841 10.517 15.4966 9.13742H13.0615L15.2668 6.93213C15.1739 6.30721 15.0589 5.70278 14.9215 5.12839L13.0299 7.02033V0.98686C12.452 0.360551 11.776 0 10.9998 0C10.8169 0 10.6342 0.00469093 10.451 0.0135619C9.90994 0.0406393 9.37935 0.107195 8.8614 0.209327V9.10496L3.10289 3.34658C2.74907 3.71169 2.41996 4.10071 2.11877 4.51184L5.80245 8.19552L6.74486 9.13761H0.160142C0.0569878 9.74339 0 10.3648 0 11.0002C0 11.7913 0.0854585 12.5619 0.243836 13.3058H8.82842L3.29048 18.8438C3.65312 19.2 4.03922 19.5318 4.44793 19.8353L8.86126 15.422V21.7903C9.37917 21.8925 9.91013 21.959 10.4512 21.9861C10.6341 21.995 10.8168 22 10.9997 22C11.776 22 12.452 21.6394 13.0299 21.0131Z',
      fill: '#E51D35'
    })]
  }));
});

const UnitedStatesOfAmericaFlag = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  return jsxs(Icon, Object.assign({
    ref: forwardedRef
  }, props, {
    children: [jsx("path", {
      d: 'M21.9514 12.0288H0.0495605V12.0291H21.9514V12.0288Z',
      fill: '#C42126'
    }), jsx("path", {
      d: 'M20.8097 6.02393H1.19031V6.02425H20.8097V6.02393Z',
      fill: '#C42126'
    }), jsx("path", {
      d: 'M21.589 8.0249H0.410156V8.02523H21.589V8.0249Z',
      fill: '#C42126'
    }), jsx("path", {
      d: 'M4.72775 20.0344H17.2723L17.273 20.0337H4.72705L4.72775 20.0344Z',
      fill: '#C42126'
    }), jsx("path", {
      d: 'M11 0C10.7839 0 10.5696 0.00780279 10.3568 0.0199714H11.6433C11.4303 0.00780279 11.216 0 11 0Z',
      fill: '#C42126'
    }), jsx("path", {
      d: 'M21.9541 10.0273H0.0454102V10.0277H21.9541V10.0273Z',
      fill: '#C42126'
    }), jsx("path", {
      d: 'M14.2512 4.02251H19.5038C18.8799 3.263 18.1548 2.59067 17.3514 2.02148H13.4072C13.7336 2.59568 14.0143 3.27322 14.2512 4.02251Z',
      fill: '#E7E7E7'
    }), jsx("path", {
      d: 'M13.4072 2.02157H17.3514C15.7208 0.866065 13.7632 0.142449 11.6432 0.0200195H11.3046C12.3024 0.145607 12.7607 0.884086 13.4072 2.02157Z',
      fill: '#DC3027'
    }), jsx("path", {
      d: 'M21.5898 8.02546C21.3942 7.32794 21.1319 6.65872 20.8096 6.02441H14.7667C14.8892 6.66689 14.9858 7.33798 15.0573 8.02546H21.5898Z',
      fill: '#E7E7E7'
    }), jsx("path", {
      d: 'M14.4269 6.02383H20.8095C20.4457 5.30843 20.0088 4.63712 19.5037 4.02246H13.9282C14.1248 4.64478 14.2918 5.3161 14.4269 6.02383Z',
      fill: '#DC3027'
    }), jsx("path", {
      d: 'M15.2887 12.0285H21.9504C21.982 11.69 21.9999 11.347 21.9999 11.0003C21.9999 10.6722 21.9827 10.3483 21.9546 10.0273H15.2903C15.312 10.6929 15.3116 11.3633 15.2887 12.0285Z',
      fill: '#E7E7E7'
    }), jsx("path", {
      d: 'M21.9547 10.0264C21.8944 9.33914 21.7706 8.67047 21.5897 8.02539H14.7766C14.845 8.68069 14.8902 9.35112 14.9123 10.0264H21.9547Z',
      fill: '#DC3027'
    }), jsx("path", {
      d: 'M14.6519 16.0312H20.7809C21.1077 15.3975 21.3742 14.7278 21.5739 14.0298H14.9482C14.8752 14.7183 14.7762 15.3892 14.6519 16.0312Z',
      fill: '#E7E7E7'
    }), jsx("path", {
      d: 'M21.5741 14.0299C21.7587 13.385 21.8869 12.7163 21.9506 12.0288H15.0812C15.0578 12.7046 15.0112 13.3749 14.9414 14.0299H21.5741Z',
      fill: '#DC3027'
    }), jsx("path", {
      d: 'M17.273 20.0338C18.088 19.4668 18.8233 18.7938 19.4571 18.0327H14.2961C14.0549 18.7851 13.7684 19.4616 13.4362 20.0338H17.273Z',
      fill: '#E7E7E7'
    }), jsx("path", {
      d: 'M14.1019 18.0326H19.4571C19.9681 17.4187 20.4117 16.7473 20.7808 16.0312H14.6068C14.4698 16.7395 14.3012 17.4111 14.1019 18.0326Z',
      fill: '#DC3027'
    }), jsx("path", {
      d: 'M10.6012 21.9922C10.579 21.9915 10.5568 21.9904 10.5345 21.9897C10.5568 21.9904 10.579 21.9915 10.6012 21.9922Z',
      fill: '#DC3027'
    }), jsx("path", {
      d: 'M11 22C13.3321 22 15.4929 21.2721 17.2725 20.0347H13.2914C12.5848 21.2519 12.1187 22 11 22Z',
      fill: '#DC3027'
    }), jsx("path", {
      d: 'M10.9999 22C10.8663 22 10.7336 21.9969 10.6013 21.9922C10.735 21.9967 10.8679 22 10.9999 22Z',
      fill: '#C42126'
    }), jsx("path", {
      d: 'M13.7715 2.02148H4.64885C3.84539 2.59067 3.12042 3.26295 2.49634 4.02251H14.6153C14.3784 3.27322 14.0979 2.59568 13.7715 2.02148Z',
      fill: '#F3F4F5'
    }), jsx("path", {
      d: 'M4.6488 2.02157H13.7715C13.1248 0.884086 12.3024 0.145607 11.3046 0.0200195H10.3568C8.2368 0.142449 6.27917 0.866065 4.6488 2.02157Z',
      fill: '#E73625'
    }), jsx("path", {
      d: 'M0.4104 8.02546H15.4043C15.3328 7.33784 15.2362 6.66689 15.1138 6.02441H1.19059C0.868212 6.65876 0.605982 7.32794 0.4104 8.02546Z',
      fill: '#F3F4F5'
    }), jsx("path", {
      d: 'M2.49625 4.02246C1.99153 4.63711 1.5542 5.30838 1.19067 6.02382H15.1137C14.9787 5.31623 14.8118 4.64496 14.6152 4.02246C14.6152 4.02246 2.49625 4.02246 2.49625 4.02246Z',
      fill: '#E73625'
    }), jsx("path", {
      d: 'M0.00012207 11.0002C0.00012207 11.3468 0.0181892 11.6898 0.0496325 12.0283H15.5386C15.5616 11.3631 15.5619 10.6929 15.5402 10.0273H0.0454524C0.0173067 10.3482 0.00012207 10.6721 0.00012207 11.0002Z',
      fill: '#F3F4F5'
    }), jsx("path", {
      d: 'M0.0454102 10.0264H15.54C15.5179 9.35098 15.4726 8.68073 15.4043 8.02539H0.410143C0.229332 8.67061 0.10551 9.33914 0.0454102 10.0264Z',
      fill: '#E73625'
    }), jsx("path", {
      d: 'M15.3989 14.0298H0.426147C0.625908 14.728 0.892503 15.3976 1.2192 16.0312H15.1025C15.2269 15.3894 15.3257 14.7184 15.3989 14.0298Z',
      fill: '#F3F4F5'
    }), jsx("path", {
      d: 'M0.426091 14.0299H15.3988C15.4685 13.3749 15.5151 12.7044 15.5386 12.0288H0.0495605C0.113283 12.7164 0.241658 13.385 0.426091 14.0299Z',
      fill: '#E73625'
    }), jsx("path", {
      d: 'M4.72706 20.0338H13.7379C14.0702 19.4615 14.3567 18.7851 14.5978 18.0327H2.54297C3.17676 18.7938 3.91195 19.4668 4.72706 20.0338Z',
      fill: '#F3F4F5'
    }), jsx("path", {
      d: 'M1.21936 16.0312C1.58846 16.7473 2.03201 17.4187 2.543 18.0326H14.5978C14.7969 17.4112 14.9655 16.7395 15.1025 16.0312H1.21936Z',
      fill: '#E73625'
    }), jsx("path", {
      d: 'M10.5346 21.9894C10.5568 21.9901 10.579 21.9911 10.6013 21.9918C10.7336 21.9965 10.8663 21.9996 10.9999 21.9996C12.1186 21.9996 13.0308 21.2516 13.7375 20.0342H4.72778C6.38805 21.1889 8.38091 21.8996 10.5346 21.9894Z',
      fill: '#E73625'
    }), jsx("path", {
      d: 'M10.7726 0.00537109C5.13567 0.120044 0.541329 4.47237 0.046875 10.0086H10.7727V0.00537109H10.7726Z',
      fill: '#283991'
    }), jsx("path", {
      d: 'M2.20104 6.23242L2.36861 6.74843H2.91155L2.47232 7.06751L2.64008 7.58389L2.20104 7.26462L1.76213 7.58389L1.92957 7.06751L1.49048 6.74843H2.03342L2.20104 6.23242Z',
      fill: '#EFEFEF'
    }), jsx("path", {
      d: 'M2.20104 8.05566L2.36861 8.57199H2.91155L2.47232 8.89107L2.64008 9.40745L2.20104 9.08819L1.76213 9.40745L1.92957 8.89107L1.49048 8.57199H2.03342L2.20104 8.05566Z',
      fill: '#EFEFEF'
    }), jsx("path", {
      d: 'M4.02447 3.49756L4.19209 4.01375H4.73485L4.29576 4.33301L4.46338 4.84902L4.02447 4.53013L3.58538 4.84902L3.753 4.33301L3.31372 4.01375H3.85667L4.02447 3.49756Z',
      fill: '#EFEFEF'
    }), jsx("path", {
      d: 'M4.02447 5.3208L4.19209 5.83699H4.73485L4.29576 6.15588L4.46338 6.67226L4.02447 6.35337L3.58538 6.67226L3.753 6.15588L3.31372 5.83699H3.85667L4.02447 5.3208Z',
      fill: '#EFEFEF'
    }), jsx("path", {
      d: 'M4.02447 7.14453L4.19209 7.66091H4.73485L4.29576 7.97962L4.46338 8.49599L4.02447 8.17678L3.58538 8.49599L3.753 7.97962L3.31372 7.66091H3.85667L4.02447 7.14453Z',
      fill: '#EFEFEF'
    }), jsx("path", {
      d: 'M0.816758 8.49598L0.649 7.97961L1.08809 7.66071H0.545475L0.533306 7.62305C0.473718 7.80734 0.419889 7.99387 0.370239 8.18248L0.377903 8.17677L0.816758 8.49598Z',
      fill: '#EFEFEF'
    }), jsx("path", {
      d: 'M1.76205 5.76075L2.20096 5.44154L2.64005 5.76075L2.47229 5.24438L2.91139 4.92517H2.36844L2.20082 4.40918L2.0332 4.92517H1.83312C1.79596 4.98146 1.76001 5.03808 1.72388 5.09521L1.92954 5.24438L1.76205 5.76075Z',
      fill: '#EFEFEF'
    }), jsx("path", {
      d: 'M4.02442 2.70677L4.46333 3.02567L4.29571 2.50965L4.73462 2.19043H4.42111C4.15484 2.3895 3.89795 2.60018 3.65115 2.82247L3.58496 3.02567L4.02442 2.70677Z',
      fill: '#EFEFEF'
    }), jsx("path", {
      d: 'M5.40857 2.11422L5.84766 1.79501L6.28657 2.11422L6.11895 1.59785L6.55785 1.27895H6.0151L5.99234 1.20947C5.80841 1.30343 5.6264 1.4012 5.44851 1.50524L5.576 1.5978L5.40857 2.11422Z',
      fill: '#EFEFEF'
    }), jsx("path", {
      d: 'M5.84779 2.58643L6.01541 3.10229H6.55817L6.11907 3.42151L6.28669 3.93789L5.84779 3.61862L5.4087 3.93789L5.57632 3.42151L5.13708 3.10229H5.67998L5.84779 2.58643Z',
      fill: '#EFEFEF'
    }), jsx("path", {
      d: 'M5.84779 4.40918L6.01541 4.92506H6.55817L6.11907 5.24428L6.28669 5.76067L5.84779 5.4414L5.4087 5.76067L5.57632 5.24428L5.13708 4.92506H5.67998L5.84779 4.40918Z',
      fill: '#EFEFEF'
    }), jsx("path", {
      d: 'M5.84779 6.23242L6.01541 6.74843H6.55817L6.11907 7.06751L6.28669 7.58389L5.84779 7.26462L5.4087 7.58389L5.57632 7.06751L5.13708 6.74843H5.67998L5.84779 6.23242Z',
      fill: '#EFEFEF'
    }), jsx("path", {
      d: 'M5.84779 8.05566L6.01541 8.57199H6.55817L6.11907 8.89107L6.28669 9.40745L5.84779 9.08819L5.4087 9.40745L5.57632 8.89107L5.13708 8.57199H5.67998L5.84779 8.05566Z',
      fill: '#EFEFEF'
    }), jsx("path", {
      d: 'M7.67115 1.67383L7.83877 2.19003H8.38153L7.94262 2.50929L8.11006 3.0253L7.67115 2.70641L7.23192 3.0253L7.39968 2.50929L6.96045 2.19003H7.50334L7.67115 1.67383Z',
      fill: '#EFEFEF'
    }), jsx("path", {
      d: 'M7.67115 3.49756L7.83877 4.01375H8.38153L7.94262 4.33301L8.11006 4.84902L7.67115 4.53013L7.23192 4.84902L7.39968 4.33301L6.96045 4.01375H7.50334L7.67115 3.49756Z',
      fill: '#EFEFEF'
    }), jsx("path", {
      d: 'M7.67115 5.3208L7.83877 5.83699H8.38153L7.94262 6.15588L8.11006 6.67226L7.67115 6.35337L7.23192 6.67226L7.39968 6.15588L6.96045 5.83699H7.50334L7.67115 5.3208Z',
      fill: '#EFEFEF'
    }), jsx("path", {
      d: 'M7.67115 7.14453L7.83877 7.66091H8.38153L7.94262 7.97962L8.11006 8.49599L7.67115 8.17678L7.23192 8.49599L7.39968 7.97962L6.96045 7.66091H7.50334L7.67115 7.14453Z',
      fill: '#EFEFEF'
    }), jsx("path", {
      d: 'M9.4944 0.762695L9.66202 1.27889H10.2048L9.76568 1.59778L9.9333 2.11416L9.4944 1.79489L9.05516 2.11416L9.22292 1.59778L8.78369 1.27889H9.32645L9.4944 0.762695Z',
      fill: '#EFEFEF'
    }), jsx("path", {
      d: 'M9.4944 2.58643L9.66202 3.10229H10.2048L9.76568 3.42151L9.9333 3.93789L9.4944 3.61862L9.05516 3.93789L9.22292 3.42151L8.78369 3.10229H9.32645L9.4944 2.58643Z',
      fill: '#EFEFEF'
    }), jsx("path", {
      d: 'M9.4944 4.40918L9.66202 4.92506H10.2048L9.76568 5.24428L9.9333 5.76067L9.4944 5.4414L9.05516 5.76067L9.22292 5.24428L8.78369 4.92506H9.32645L9.4944 4.40918Z',
      fill: '#EFEFEF'
    }), jsx("path", {
      d: 'M9.4944 6.23242L9.66202 6.74843H10.2048L9.76568 7.06751L9.9333 7.58389L9.4944 7.26462L9.05516 7.58389L9.22292 7.06751L8.78369 6.74843H9.32645L9.4944 6.23242Z',
      fill: '#EFEFEF'
    }), jsx("path", {
      d: 'M9.4944 8.05566L9.66202 8.57199H10.2048L9.76568 8.89107L9.9333 9.40745L9.4944 9.08819L9.05516 9.40745L9.22292 8.89107L8.78369 8.57199H9.32645L9.4944 8.05566Z',
      fill: '#EFEFEF'
    })]
  }));
});

const AltKeyIcon = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  return jsxs(Icon, Object.assign({
    ref: forwardedRef
  }, props, {
    children: [jsx("path", {
      d: 'M6.99222 8.42743L9.09691 12.9274C9.18525 13.1102 9.22942 13.2473 9.22942 13.3387C9.22942 13.5323 9.07872 13.707 8.77731 13.8629C8.60062 13.9543 8.4603 14 8.35637 14C8.25763 14 8.17448 13.9758 8.10692 13.9274C8.04456 13.879 7.99779 13.828 7.96661 13.7742C7.94063 13.7204 7.90165 13.6398 7.84969 13.5323L7.44434 12.6613H5.28509L4.87974 13.5323C4.82777 13.6398 4.7862 13.7178 4.75502 13.7661C4.72903 13.8145 4.68226 13.8656 4.6147 13.9194C4.55234 13.9678 4.4692 13.9919 4.36526 13.9919C4.26652 13.9919 4.12881 13.9462 3.95212 13.8548C3.65071 13.7043 3.5 13.5323 3.5 13.3387C3.5 13.2473 3.54417 13.1102 3.63252 12.9274L5.7372 8.41936C5.79437 8.29571 5.88011 8.19625 5.99444 8.12098C6.11397 8.04571 6.23869 8.00807 6.36861 8.00807C6.64923 8.00807 6.8571 8.14786 6.99222 8.42743ZM6.36081 10.3629L5.84634 11.4678H6.88309L6.36081 10.3629Z'
    }), jsx("path", {
      d: 'M11.0352 12.7258H13.1554C13.3269 12.7258 13.4516 12.7473 13.5296 12.7903C13.6075 12.828 13.6595 12.8898 13.6855 12.9758C13.7115 13.0618 13.7245 13.1774 13.7245 13.3226C13.7245 13.4624 13.7115 13.5753 13.6855 13.6613C13.6595 13.7473 13.6153 13.8065 13.553 13.8387C13.4542 13.8925 13.3191 13.9194 13.1476 13.9194H10.3414C9.97761 13.9194 9.76455 13.8172 9.70219 13.6129C9.67101 13.5269 9.65542 13.3898 9.65542 13.2016V8.71775C9.65542 8.5941 9.65801 8.5027 9.66321 8.44356C9.6736 8.37904 9.69959 8.30646 9.74116 8.22582C9.81392 8.08065 10.0166 8.00807 10.3492 8.00807C10.713 8.00807 10.9286 8.10754 10.9962 8.30646C11.0222 8.39786 11.0352 8.53764 11.0352 8.72582V12.7258Z'
    }), jsx("path", {
      d: 'M13.6047 8H17.9388C18.105 8 18.2272 8.02151 18.3051 8.06452C18.3831 8.10215 18.435 8.16398 18.461 8.25C18.487 8.33602 18.5 8.44892 18.5 8.58871C18.5 8.72849 18.487 8.8414 18.461 8.92742C18.435 9.00806 18.3909 9.06452 18.3285 9.09677C18.235 9.14516 18.1024 9.16935 17.931 9.16935H16.4421V13.2258C16.4421 13.3495 16.4369 13.4409 16.4265 13.5C16.4213 13.5591 16.3979 13.629 16.3563 13.7097C16.32 13.7849 16.2524 13.8387 16.1537 13.871C16.0549 13.9032 15.925 13.9194 15.7639 13.9194C15.6028 13.9194 15.4729 13.9032 15.3742 13.871C15.2806 13.8387 15.2131 13.7849 15.1715 13.7097C15.1351 13.629 15.1117 13.5591 15.1013 13.5C15.0961 13.4355 15.0935 13.3414 15.0935 13.2177V9.16935H13.5969C13.4306 9.16935 13.3084 9.15054 13.2305 9.1129C13.1525 9.06989 13.1006 9.00538 13.0746 8.91936C13.0486 8.83333 13.0356 8.72043 13.0356 8.58064C13.0356 8.44086 13.0486 8.33065 13.0746 8.25C13.1006 8.16398 13.1447 8.10484 13.2071 8.07258C13.3006 8.02419 13.4332 8 13.6047 8Z'
    })]
  }));
});

const BackspaceKeyIcon = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  return jsxs(Icon, Object.assign({
    ref: forwardedRef
  }, props, {
    children: [jsx("path", {
      d: 'M6.5 11.5C6.5 10.8096 7.09695 10.25 7.83333 10.25L18.6667 10.25C19.403 10.25 20 10.8096 20 11.5C20 12.1904 19.403 12.75 18.6667 12.75L7.83333 12.75C7.09695 12.75 6.5 12.1904 6.5 11.5Z'
    }), jsx("path", {
      d: 'M7.38094 7.27624L2.99954 10.7299C2.49059 11.1311 2.49181 11.903 3.00201 12.3026L7.38342 15.7339C8.03979 16.248 9 15.7804 9 14.9467L9 8.06158C9 7.22642 8.03683 6.75922 7.38094 7.27624Z'
    })]
  }));
});

const CapsKeyIcon = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  return jsxs(Icon, Object.assign({
    ref: forwardedRef
  }, props, {
    children: [jsx("path", {
      d: 'M11 7C11.5523 7 12 7.50144 12 8.12L12 12.88C12 13.4986 11.5523 14 11 14C10.4477 14 10 13.4986 10 12.88L10 8.12C10 7.50144 10.4477 7 11 7Z'
    }), jsx("path", {
      d: 'M7 16C7 15.4477 7.47756 15 8.06667 15L13.9333 15C14.5224 15 15 15.4477 15 16C15 16.5523 14.5224 17 13.9333 17L8.06667 17C7.47756 17 7 16.5523 7 16Z'
    }), jsx("path", {
      d: 'M14.6277 8.35859L11.7535 4.92065C11.3529 4.44153 10.6161 4.4427 10.217 4.92309L7.36137 8.36104C6.82012 9.01266 7.28352 10 8.13062 10L13.8605 10C14.7091 10 15.172 9.00963 14.6277 8.35859Z'
    })]
  }));
});

const CtrlKeyIcon = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  return jsxs(Icon, Object.assign({
    ref: forwardedRef
  }, props, {
    children: [jsx("path", {
      d: 'M4.66949 12.384L4.80913 12.28C4.98498 12.1733 5.1091 12.12 5.18151 12.12C5.34184 12.12 5.5151 12.2693 5.70129 12.568C5.81507 12.7547 5.87196 12.904 5.87196 13.016C5.87196 13.128 5.83576 13.2213 5.76335 13.296C5.69612 13.3707 5.61595 13.4373 5.52286 13.496C5.42976 13.5547 5.33926 13.6107 5.25133 13.664C5.16858 13.7173 4.99532 13.7867 4.73155 13.872C4.46778 13.9573 4.21177 14 3.96352 14C3.72044 14 3.47219 13.968 3.21876 13.904C2.97051 13.8347 2.71191 13.7227 2.44297 13.568C2.1792 13.408 1.94129 13.216 1.72924 12.992C1.51719 12.7627 1.34135 12.472 1.20171 12.12C1.06724 11.7627 1 11.376 1 10.96C1 10.544 1.06724 10.168 1.20171 9.832C1.33618 9.49067 1.50685 9.21067 1.71373 8.992C1.92578 8.768 2.16627 8.58133 2.43521 8.432C2.94206 8.144 3.4515 8 3.96352 8C4.2066 8 4.45227 8.04 4.70052 8.12C4.95395 8.19467 5.14531 8.272 5.27461 8.352L5.4608 8.464C5.55389 8.52267 5.6263 8.57067 5.67802 8.608C5.81249 8.72 5.87972 8.848 5.87972 8.992C5.87972 9.13067 5.82542 9.27733 5.71681 9.432C5.5151 9.72 5.33408 9.864 5.17375 9.864C5.08066 9.864 4.94877 9.80533 4.7781 9.688C4.56088 9.50667 4.27125 9.416 3.90921 9.416C3.57304 9.416 3.24203 9.536 2.9162 9.776C2.76104 9.89333 2.63175 10.0587 2.52831 10.272C2.42487 10.4853 2.37315 10.728 2.37315 11C2.37315 11.2667 2.42487 11.5067 2.52831 11.72C2.63175 11.9333 2.76363 12.1013 2.92396 12.224C3.23945 12.4587 3.56787 12.576 3.90921 12.576C4.06954 12.576 4.21953 12.5547 4.35917 12.512C4.50399 12.4693 4.60743 12.4267 4.66949 12.384Z'
    }), jsx("path", {
      d: 'M6.75412 8.048H11.0675C11.233 8.048 11.3546 8.06933 11.4321 8.112C11.5097 8.14933 11.5614 8.21067 11.5873 8.296C11.6132 8.38133 11.6261 8.49333 11.6261 8.632C11.6261 8.77067 11.6132 8.88267 11.5873 8.968C11.5614 9.048 11.5175 9.104 11.4554 9.136C11.3623 9.184 11.2304 9.208 11.0598 9.208H9.578V13.232C9.578 13.3547 9.57283 13.4453 9.56249 13.504C9.55731 13.5627 9.53404 13.632 9.49266 13.712C9.45646 13.7867 9.38922 13.84 9.29096 13.872C9.19269 13.904 9.06339 13.92 8.90306 13.92C8.74273 13.92 8.61343 13.904 8.51517 13.872C8.42207 13.84 8.35484 13.7867 8.31346 13.712C8.27726 13.632 8.25398 13.5627 8.24364 13.504C8.23847 13.44 8.23588 13.3467 8.23588 13.224V9.208H6.74636C6.58086 9.208 6.45932 9.18933 6.38174 9.152C6.30416 9.10933 6.25245 9.04533 6.22659 8.96C6.20073 8.87467 6.1878 8.76267 6.1878 8.624C6.1878 8.48533 6.20073 8.376 6.22659 8.296C6.25245 8.21067 6.29641 8.152 6.35847 8.12C6.45156 8.072 6.58345 8.048 6.75412 8.048Z'
    }), jsx("path", {
      d: 'M16.4084 12.928C16.486 13.12 16.5248 13.2587 16.5248 13.344C16.5248 13.5467 16.3645 13.7173 16.0438 13.856C15.8783 13.9307 15.7438 13.968 15.6404 13.968C15.5421 13.968 15.4594 13.944 15.3921 13.896C15.3301 13.8427 15.2835 13.7893 15.2525 13.736C15.2008 13.6347 14.9991 13.152 14.6474 12.288L14.4069 12.304H13.4294V13.208C13.4294 13.3307 13.4242 13.424 13.4139 13.488C13.4087 13.5467 13.3854 13.616 13.344 13.696C13.2716 13.84 13.0699 13.912 12.7389 13.912C12.3769 13.912 12.1648 13.8133 12.1028 13.616C12.0717 13.5253 12.0562 13.3867 12.0562 13.2V8.76C12.0562 8.63733 12.0588 8.54667 12.064 8.488C12.0743 8.424 12.1002 8.352 12.1416 8.272C12.214 8.128 12.4157 8.056 12.7467 8.056H14.4224C14.8775 8.056 15.3197 8.22667 15.749 8.568C15.9559 8.73333 16.1265 8.95733 16.261 9.24C16.3955 9.52267 16.4627 9.83733 16.4627 10.184C16.4627 10.7867 16.2688 11.2827 15.8809 11.672C15.9947 11.9547 16.1705 12.3733 16.4084 12.928ZM13.4294 10.888H14.4224C14.5724 10.888 14.7224 10.8293 14.8723 10.712C15.0223 10.5947 15.0973 10.4187 15.0973 10.184C15.0973 9.94933 15.0223 9.77333 14.8723 9.656C14.7224 9.53333 14.5672 9.472 14.4069 9.472H13.4294V10.888Z'
    }), jsx("path", {
      d: 'M18.3235 12.736H20.4337C20.6043 12.736 20.7285 12.7573 20.8061 12.8C20.8836 12.8373 20.9354 12.8987 20.9612 12.984C20.9871 13.0693 21 13.184 21 13.328C21 13.4667 20.9871 13.5787 20.9612 13.664C20.9354 13.7493 20.8914 13.808 20.8293 13.84C20.7311 13.8933 20.5966 13.92 20.4259 13.92H17.6331C17.271 13.92 17.059 13.8187 16.9969 13.616C16.9659 13.5307 16.9504 13.3947 16.9504 13.208V8.76C16.9504 8.63733 16.953 8.54667 16.9581 8.488C16.9685 8.424 16.9943 8.352 17.0357 8.272C17.1081 8.128 17.3098 8.056 17.6408 8.056C18.0029 8.056 18.2175 8.15467 18.2847 8.352C18.3106 8.44267 18.3235 8.58133 18.3235 8.768V12.736Z'
    })]
  }));
});

const EnterKeyIcon = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  return jsxs(Icon, Object.assign({
    ref: forwardedRef
  }, props, {
    children: [jsx("path", {
      d: 'M6.5 12.5C6.5 11.8096 7.09695 11.25 7.83333 11.25L18.6667 11.25C19.403 11.25 20 11.8096 20 12.5C20 13.1904 19.403 13.75 18.6667 13.75L7.83333 13.75C7.09695 13.75 6.5 13.1904 6.5 12.5Z'
    }), jsx("path", {
      d: 'M18.75 7C19.4404 7 20 7.59695 20 8.33333L20 12.414C20 13.1504 19.4404 13.7473 18.75 13.7473C18.0596 13.7473 17.5 13.1504 17.5 12.414L17.5 8.33333C17.5 7.59695 18.0596 7 18.75 7Z'
    }), jsx("path", {
      d: 'M7.38094 8.27624L2.99954 11.7299C2.49059 12.1311 2.49181 12.903 3.00201 13.3026L7.38342 16.7339C8.03979 17.248 9 16.7804 9 15.9467L9 9.06158C9 8.22642 8.03683 7.75922 7.38094 8.27624Z'
    })]
  }));
});

const EscKeyIcon = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  return jsxs(Icon, Object.assign({
    ref: forwardedRef
  }, props, {
    children: [jsx("path", {
      d: 'M5.35063 12.5139H7.70087C7.81787 12.5139 7.90436 12.5192 7.96031 12.5298C8.02136 12.5351 8.09003 12.5589 8.16634 12.6013C8.30369 12.6755 8.37237 12.8821 8.37237 13.2212C8.37237 13.5921 8.27826 13.8093 8.09003 13.8728C8.00355 13.9046 7.87129 13.9205 7.69324 13.9205H4.6715C4.3154 13.9205 4.10683 13.8199 4.04578 13.6185C4.01526 13.5338 4 13.3987 4 13.2132V8.7947C4 8.5245 4.04833 8.34172 4.14498 8.24636C4.24164 8.1457 4.42477 8.09536 4.69439 8.09536H7.70087C7.81787 8.09536 7.90436 8.10066 7.96031 8.11126C8.02136 8.11656 8.09003 8.1404 8.16634 8.18278C8.30369 8.25695 8.37237 8.46358 8.37237 8.80265C8.37237 9.17351 8.27826 9.39073 8.09003 9.4543C8.00355 9.48609 7.87129 9.50199 7.69324 9.50199H5.35063V10.3046H6.8615C6.9785 10.3046 7.06498 10.3099 7.12094 10.3205C7.18199 10.3258 7.25066 10.3497 7.32697 10.3921C7.46432 10.4662 7.533 10.6728 7.533 11.0119C7.533 11.3828 7.43634 11.6 7.24303 11.6636C7.15655 11.6954 7.02429 11.7113 6.84624 11.7113H5.35063V12.5139Z'
    }), jsx("path", {
      d: 'M8.94997 13.102C8.81771 12.9325 8.75158 12.7815 8.75158 12.649C8.75158 12.5113 8.86095 12.3311 9.0797 12.1086C9.20687 11.9815 9.34168 11.9179 9.48412 11.9179C9.62656 11.9179 9.82496 12.0503 10.0793 12.3152C10.1505 12.4053 10.2523 12.4927 10.3845 12.5775C10.5168 12.657 10.6389 12.6967 10.7508 12.6967C11.2239 12.6967 11.4605 12.4954 11.4605 12.0927C11.4605 11.9709 11.3943 11.8702 11.2621 11.7907C11.1349 11.706 10.9746 11.645 10.7813 11.6079C10.588 11.5709 10.3795 11.5126 10.1556 11.4331C9.93179 11.3483 9.72322 11.2503 9.52991 11.1391C9.33659 11.0278 9.17381 10.853 9.04154 10.6146C8.91436 10.3709 8.85078 10.0795 8.85078 9.7404C8.85078 9.27417 9.01611 8.86887 9.34677 8.5245C9.68252 8.17483 10.1378 8 10.7127 8C11.0179 8 11.2951 8.04238 11.5444 8.12715C11.7988 8.20662 11.9743 8.28874 12.0709 8.37351L12.2617 8.5245C12.4194 8.67815 12.4982 8.80795 12.4982 8.91391C12.4982 9.01987 12.4372 9.16556 12.3151 9.35099C12.1421 9.61589 11.9641 9.74834 11.781 9.74834C11.6741 9.74834 11.5419 9.69536 11.3842 9.5894C11.3689 9.57881 11.3384 9.55232 11.2926 9.50993C11.2519 9.46755 11.2137 9.43311 11.1781 9.40662C11.0713 9.33775 10.9339 9.30331 10.7661 9.30331C10.6033 9.30331 10.4659 9.3457 10.354 9.43046C10.2472 9.50993 10.1938 9.62384 10.1938 9.77219C10.1938 9.91523 10.2574 10.0318 10.3845 10.1219C10.5168 10.2119 10.6796 10.2728 10.8729 10.3046C11.0662 10.3364 11.2773 10.3868 11.5062 10.4556C11.7352 10.5192 11.9463 10.5987 12.1396 10.694C12.3329 10.7894 12.4931 10.9563 12.6203 11.1947C12.7526 11.4278 12.8187 11.7166 12.8187 12.0609C12.8187 12.4053 12.7526 12.7099 12.6203 12.9748C12.4881 13.2344 12.3151 13.4358 12.1014 13.5788C11.6894 13.8596 11.2493 14 10.7813 14C10.5422 14 10.3159 13.9709 10.1022 13.9126C9.88855 13.849 9.71558 13.7722 9.58332 13.6821C9.3137 13.5126 9.12548 13.3483 9.01865 13.1894L8.94997 13.102Z'
    }), jsx("path", {
      d: 'M16.8096 12.3947L16.947 12.2914C17.1199 12.1854 17.242 12.1325 17.3132 12.1325C17.4709 12.1325 17.6414 12.2808 17.8245 12.5775C17.9364 12.7629 17.9924 12.9113 17.9924 13.0225C17.9924 13.1338 17.9568 13.2265 17.8855 13.3007C17.8194 13.3748 17.7406 13.4411 17.649 13.4993C17.5574 13.5576 17.4684 13.6132 17.3819 13.6662C17.3005 13.7192 17.1301 13.7881 16.8707 13.8728C16.6112 13.9576 16.3594 14 16.1152 14C15.8761 14 15.632 13.9682 15.3827 13.9046C15.1385 13.8358 14.8841 13.7245 14.6196 13.5709C14.3602 13.4119 14.1262 13.2212 13.9176 12.9987C13.709 12.7709 13.5361 12.4821 13.3987 12.1325C13.2664 11.7775 13.2003 11.3934 13.2003 10.9801C13.2003 10.5669 13.2664 10.1934 13.3987 9.8596C13.531 9.52053 13.6988 9.24238 13.9023 9.02517C14.1109 8.80265 14.3475 8.61722 14.612 8.46887C15.1105 8.18278 15.6116 8.03974 16.1152 8.03974C16.3543 8.03974 16.596 8.07947 16.8401 8.15894C17.0894 8.23311 17.2776 8.30993 17.4048 8.3894L17.5879 8.50066C17.6795 8.55894 17.7507 8.60662 17.8016 8.64371C17.9339 8.75497 18 8.88212 18 9.02517C18 9.16291 17.9466 9.30861 17.8398 9.46225C17.6414 9.74834 17.4633 9.89139 17.3056 9.89139C17.214 9.89139 17.0843 9.83311 16.9164 9.71656C16.7028 9.53642 16.4179 9.44636 16.0618 9.44636C15.7311 9.44636 15.4056 9.56556 15.0851 9.80397C14.9325 9.92053 14.8053 10.0848 14.7036 10.2967C14.6018 10.5086 14.5509 10.7497 14.5509 11.0199C14.5509 11.2848 14.6018 11.5232 14.7036 11.7351C14.8053 11.947 14.935 12.1139 15.0927 12.2358C15.403 12.4689 15.7261 12.5854 16.0618 12.5854C16.2195 12.5854 16.367 12.5642 16.5044 12.5219C16.6468 12.4795 16.7486 12.4371 16.8096 12.3947Z'
    })]
  }));
});

const SpaceKeyIcon = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  return jsx(Icon, Object.assign({
    ref: forwardedRef
  }, props, {
    children: jsx("path", {
      d: 'M19 14.25C19 14.9404 18.403 15.5 17.6667 15.5L4.33333 15.5C3.59695 15.5 3 14.9404 3 14.25V10.3333C3 9.59695 3.55964 9 4.25 9C4.94036 9 5.5 9.59695 5.5 10.3333L5.5 13L16.5 13V10.3333C16.5 9.59695 17.0596 9 17.75 9C18.4404 9 19 9.59695 19 10.3333L19 14.25Z'
    })
  }));
});

const TabKeyIcon = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  return jsxs(Icon, Object.assign({
    ref: forwardedRef
  }, props, {
    children: [jsx("path", {
      d: 'M16 14.25C16 14.8023 15.403 15.25 14.6667 15.25L4.33333 15.25C3.59695 15.25 3 14.8023 3 14.25C3 13.6977 3.59695 13.25 4.33333 13.25L14.6667 13.25C15.403 13.25 16 13.6977 16 14.25Z'
    }), jsx("path", {
      d: 'M6 7.75C6 7.19771 6.59695 6.75 7.33333 6.75L17.6667 6.75C18.403 6.75 19 7.19771 19 7.75C19 8.30228 18.403 8.75 17.6667 8.75L7.33333 8.75C6.59695 8.75 6 8.30228 6 7.75Z'
    }), jsx("path", {
      d: 'M17.5 18C16.9477 18 16.5 17.403 16.5 16.6666L16.5 11.3333C16.5 10.5969 16.9477 9.99996 17.5 9.99996C18.0523 9.99996 18.5 10.5969 18.5 11.3333L18.5 16.6666C18.5 17.403 18.0523 18 17.5 18Z'
    }), jsx("path", {
      d: 'M4.5 4.00004C5.05229 4.00004 5.5 4.59699 5.5 5.33337L5.5 10.6667C5.5 11.4031 5.05229 12 4.5 12C3.94772 12 3.5 11.4031 3.5 10.6667L3.5 5.33337C3.5 4.59699 3.94772 4.00004 4.5 4.00004Z'
    }), jsx("path", {
      d: 'M13.7082 17.2862L16.294 14.6921C16.6839 14.3009 16.6829 13.6677 16.2917 13.2778L13.706 10.7004C13.0755 10.072 12 10.5186 12 11.4087L12 16.5803C12 17.4719 13.0788 17.9178 13.7082 17.2862Z'
    }), jsx("path", {
      d: 'M8.29175 4.71378L5.70597 7.30794C5.31607 7.6991 5.3171 8.33227 5.70826 8.72216L8.29404 11.2996C8.92448 11.928 10 11.4814 10 10.5913L10 5.41974C10 4.52806 8.92125 4.08225 8.29175 4.71378Z'
    })]
  }));
});

const WindowsKeyIcon = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  return jsxs(Icon, Object.assign({
    ref: forwardedRef
  }, props, {
    children: [jsx("path", {
      d: 'M3 3H10V10H3V3Z'
    }), jsx("path", {
      d: 'M12 3H19V10H12V3Z'
    }), jsx("path", {
      d: 'M3 12H10V19H3V12Z'
    }), jsx("path", {
      d: 'M12 12H19V19H12V12Z'
    })]
  }));
});

const ArrowRightIcon = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  return jsx(Icon, Object.assign({
    ref: forwardedRef
  }, props, {
    children: jsx("path", {
      d: 'M16.0694 8L19 10.9207L16.0791 13.8513L15.1023 12.8777L16.3534 11.6223L9.17934 11.6469C8.53342 11.6491 7.91459 11.9067 7.45785 12.3634L7.3885 12.4328C6.5806 13.2407 5.27074 13.2407 4.46283 12.4328C3.65493 11.6249 3.65493 10.315 4.46283 9.50712C5.27074 8.69922 6.5806 8.69922 7.3885 9.50712L7.44069 9.55931C7.89637 10.015 8.51505 10.27 9.15949 10.2678L16.3663 10.2431L15.0958 8.97687L16.0694 8ZM5.43806 11.4576C5.70736 11.7269 6.14398 11.7269 6.41328 11.4576C6.68258 11.1883 6.68258 10.7516 6.41328 10.4823C6.14398 10.213 5.70736 10.213 5.43806 10.4823L5.3684 10.552C5.13757 10.7828 5.13757 11.1571 5.3684 11.3879L5.43806 11.4576Z'
    })
  }));
});

const CheckIcon = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  return jsx(Icon, Object.assign({
    ref: forwardedRef
  }, props, {
    children: jsx("path", {
      d: 'M3.31513 10.0547C3.77319 9.52548 4.56262 9.48002 5.0784 9.95312L9.31385 13.8382L16.5722 5.42993C17.0296 4.90012 17.819 4.85357 18.3354 5.32596C18.8517 5.79835 18.8996 6.61079 18.4422 7.14061L11.1816 15.5514L10.1079 16.7327C9.73276 17.1454 9.09254 17.1715 8.68508 16.7907L3.41964 11.8694C2.90387 11.3963 2.85708 10.5838 3.31513 10.0547Z'
    })
  }));
});

const CloseIcon = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  return jsx(Icon, Object.assign({
    ref: forwardedRef
  }, props, {
    children: jsx("path", {
      d: 'M5.65713 5.34315C6.17783 4.82245 7.02204 4.82245 7.54274 5.34315L11.314 9.11438L15.0852 5.34315C15.6059 4.82245 16.4501 4.82245 16.9708 5.34315C17.4915 5.86385 17.4915 6.70806 16.9708 7.22876L13.1996 11L16.9708 14.7712C17.4915 15.2919 17.4915 16.1362 16.9708 16.6569C16.4501 17.1776 15.6059 17.1776 15.0852 16.6569L11.314 12.8856L7.54274 16.6569C7.02204 17.1776 6.17783 17.1776 5.65713 16.6569C5.13643 16.1362 5.13643 15.2919 5.65713 14.7712L9.42836 11L5.65713 7.22876C5.13643 6.70807 5.13643 5.86385 5.65713 5.34315Z'
    })
  }));
});

const DownloadIcon = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  return jsxs(Icon, Object.assign({
    ref: forwardedRef
  }, props, {
    children: [jsx("path", {
      d: 'M19 16.75C19 17.4404 18.403 18 17.6667 18L4.33333 18C3.59695 18 3 17.4404 3 16.75V12.8333C3 12.097 3.55964 11.5 4.25 11.5C4.94036 11.5 5.5 12.097 5.5 12.8333L5.5 15.5L16.5 15.5V12.8333C16.5 12.097 17.0596 11.5 17.75 11.5C18.4404 11.5 19 12.097 19 12.8333L19 16.75Z'
    }), jsx("path", {
      d: 'M11.0001 11C10.4479 11 10.0001 10.4986 10.0001 9.88L10.0001 5.12C10.0001 4.50144 10.4479 4 11.0001 4C11.5524 4 12.0001 4.50144 12.0001 5.12L12.0001 9.88C12.0001 10.4986 11.5524 11 11.0001 11Z'
    }), jsx("path", {
      d: 'M7.37241 9.64141L10.2466 13.0794C10.6472 13.5585 11.3841 13.5573 11.7831 13.0769L14.6388 9.63896C15.18 8.98734 14.7166 8 13.8695 8L8.13961 8C7.29103 8 6.82812 8.99037 7.37241 9.64141Z'
    })]
  }));
});

const EditIcon = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  return jsxs(Icon, Object.assign({
    ref: forwardedRef
  }, props, {
    children: [jsx("path", {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M17.6975 3.22347C17.3996 2.92551 16.9165 2.92551 16.6185 3.22347L15.9529 3.88905C15.1021 3.48261 14.0522 3.63175 13.3475 4.33646L5.25496 12.429L9.57099 16.745L17.6635 8.65249C18.3682 7.94778 18.5174 6.89788 18.1109 6.04707L18.7765 5.38148C19.0745 5.08352 19.0745 4.60044 18.7765 4.30248L17.6975 3.22347ZM14.4412 9.71686L9.57099 14.587L7.41297 12.429L12.2831 7.55884L14.4412 9.71686ZM15.8285 8.32956L16.5845 7.57348C16.8825 7.27552 16.8825 6.79243 16.5845 6.49447L15.5055 5.41547C15.2076 5.11751 14.7245 5.11751 14.4265 5.41547L13.6704 6.17155L15.8285 8.32956Z'
    }), jsx("path", {
      d: 'M3 18.9845L4.61881 13.0496L8.93454 17.3659L3 18.9845Z'
    })]
  }));
});

const ExternalIcon = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  return jsxs(Icon, Object.assign({
    ref: forwardedRef
  }, props, {
    children: [jsx("path", {
      d: 'M4 21C3.5 21 3 20.5 3 20L3 6C3 5.5 3.5 5 4 5C4.5 5 5 5.5 5 6V20C5 20.5 4.5 21 4 21Z'
    }), jsx("path", {
      d: 'M3 20C3 19.5 3.5 19 4 19L17.6667 19C18.403 19 19 19.4477 19 20C19 20.5523 18.403 21 17.6667 21H4C3.5 21 3 20.5 3 20Z'
    }), jsx("path", {
      d: 'M18 11C18.5 11 19 11.5 19 12L19 20C19 20.5 18.609 21 18 21C17.391 21 17 20.5 17 20V12C17 11.5 17.5 11 18 11Z'
    }), jsx("path", {
      d: 'M3 6C3 5.5 3.5 5 4 5L12 5C12.5 5 13 5.5 13 6C13 6.5 12.5 7 12 7L4 7C3.5 7 3 6.5 3 6Z'
    }), jsx("path", {
      d: 'M10.7071 13.1421C10.3536 12.7886 10.3536 12.0814 10.7071 11.7279L16.364 6.07104C16.7175 5.71748 17.4246 5.71748 17.7782 6.07104C18.1317 6.42459 18.1317 7.1317 17.7782 7.48525L12.1213 13.1421C11.7678 13.4957 11.0607 13.4957 10.7071 13.1421Z'
    }), jsx("path", {
      d: 'M20.5915 8.52356L21.1523 3.78798C21.2285 3.14443 20.6818 2.59949 20.0385 2.67771L15.3164 3.25191C14.4888 3.35255 14.1405 4.36219 14.73 4.95171L18.8914 9.11308C19.4819 9.70363 20.4933 9.35292 20.5915 8.52356Z'
    })]
  }));
});

const EyeIcon = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  return jsxs(Icon, Object.assign({
    ref: forwardedRef
  }, props, {
    children: [jsx("path", {
      d: 'M19 10.3333C19 11.0697 18.403 11.6667 17.6667 11.6667C16.9303 11.6667 13.6035 10.6667 11 10.6667C8.3965 10.6667 5.06971 11.6667 4.33333 11.6667C3.59695 11.6667 3 11.0697 3 10.3333C3 9.59694 3.3527 9.16667 4.33333 8.99999C5.31396 8.83331 8.3965 7.99999 11 7.99999C13.6035 7.99999 16.9262 8.89319 17.6667 8.99999C18.4071 9.10679 19 9.59694 19 10.3333Z'
    }), jsx("path", {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11 18C12.6569 18 14 16.6569 14 15C14 13.3431 12.6569 12 11 12C9.34315 12 8 13.3431 8 15C8 16.6569 9.34315 18 11 18ZM11 16.2857C11.7101 16.2857 12.2857 15.7101 12.2857 15C12.2857 14.2899 11.7101 13.7143 11 13.7143C10.2899 13.7143 9.71429 14.2899 9.71429 15C9.71429 15.7101 10.2899 16.2857 11 16.2857Z'
    }), jsx("path", {
      d: 'M15.7712 6.1429C15.9618 5.43161 16.6929 5.0095 17.4042 5.20009C18.1155 5.39068 18.5376 6.12179 18.347 6.83308L17.2305 11L14.6475 10.3368L15.7712 6.1429Z'
    }), jsx("path", {
      d: 'M11.3586 4C12.0949 4 12.6919 4.59695 12.6919 5.33333L12.6919 10L10.0252 10L10.0252 5.33333C10.0252 4.59695 10.6222 4 11.3586 4Z'
    }), jsx("path", {
      d: 'M5.28778 5.27258C5.99907 5.08199 6.73019 5.5041 6.92078 6.21539L8.00771 10.2719L5.44207 11L4.34497 6.90558C4.15438 6.19429 4.57649 5.46317 5.28778 5.27258Z'
    })]
  }));
});

const EyeClosedIcon = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  return jsxs(Icon, Object.assign({
    ref: forwardedRef
  }, props, {
    children: [jsx("path", {
      d: 'M3 9.33333C3 8.59695 3.59695 8 4.33333 8C5.06971 8 8.3965 9 11 9C13.6035 9 16.9303 8 17.6667 8C18.403 8 19 8.59695 19 9.33333C19 10.0697 18.6473 10.5 17.6667 10.6667C16.686 10.8333 13.6035 11.6667 11 11.6667C8.3965 11.6667 5.07381 10.7735 4.33333 10.6667C3.59286 10.5599 3 10.0697 3 9.33333Z'
    }), jsx("path", {
      d: 'M6.60673 14.1904C6.41614 14.9017 5.68502 15.3238 4.97373 15.1333C4.26244 14.9427 3.84033 14.2115 4.03092 13.5003L5.14745 9.33335L7.73047 9.99658L6.60673 14.1904Z'
    }), jsx("path", {
      d: 'M11.0194 16.3333C10.283 16.3333 9.68604 15.7364 9.68604 15L9.68603 10.3333L12.3527 10.3333L12.3527 15C12.3527 15.7364 11.7557 16.3333 11.0194 16.3333Z'
    }), jsx("path", {
      d: 'M17.0901 15.0608C16.3789 15.2514 15.6477 14.8292 15.4572 14.118L14.3702 10.0614L16.9359 9.33334L18.033 13.4278C18.2235 14.1391 17.8014 14.8702 17.0901 15.0608Z'
    })]
  }));
});

const MinusIcon = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  return jsx(Icon, Object.assign({
    ref: forwardedRef
  }, props, {
    children: jsx("path", {
      d: 'M3.31396 11C3.31396 10.2636 3.91092 9.66666 4.6473 9.66666L17.9806 9.66666C18.717 9.66666 19.314 10.2636 19.314 11C19.314 11.7364 18.717 12.3333 17.9806 12.3333L4.6473 12.3333C3.91092 12.3333 3.31396 11.7364 3.31396 11Z'
    })
  }));
});

const ModBrosIcon = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  return jsxs(Icon, Object.assign({
    ref: forwardedRef
  }, props, {
    children: [jsx("path", {
      d: 'M11.0006 3C9.17097 3.00046 7.39664 3.62879 5.97299 4.78039C5.80152 4.69145 5.60573 4.66114 5.41546 4.69409C5.2252 4.72703 5.05091 4.82141 4.91916 4.96285C4.78742 5.10428 4.70545 5.28501 4.68577 5.47747C4.66608 5.66993 4.70975 5.86356 4.81011 6.02883C4.91048 6.19411 5.06204 6.32196 5.24168 6.39289C5.42131 6.46382 5.61917 6.47394 5.80509 6.42171C5.991 6.36948 6.15476 6.25775 6.27141 6.10358C6.38805 5.9494 6.45117 5.76124 6.45115 5.56777C6.45102 5.46349 6.43277 5.36003 6.39721 5.26203C7.70361 4.2122 9.32816 3.63997 11.0028 3.63977C15.0608 3.63977 18.3615 6.94704 18.3615 11.013C18.3662 12.5823 17.8667 14.1115 16.9368 15.3743L17.4519 15.7536C18.4618 14.3806 19.0046 12.7187 19 11.013C18.9978 6.59343 15.4115 3 11.0006 3ZM5.56615 5.96237C5.48826 5.96237 5.41212 5.93922 5.34736 5.89586C5.2826 5.85251 5.23212 5.79088 5.20231 5.71878C5.17251 5.64667 5.16471 5.56733 5.1799 5.49079C5.1951 5.41425 5.2326 5.34394 5.28768 5.28875C5.34276 5.23356 5.41293 5.19598 5.48932 5.18076C5.56571 5.16553 5.6449 5.17335 5.71686 5.20321C5.78882 5.23308 5.85032 5.28365 5.89359 5.34855C5.93687 5.41344 5.95996 5.48973 5.95996 5.56777C5.95996 5.67242 5.91847 5.77279 5.84462 5.84679C5.77076 5.92079 5.6706 5.96237 5.56615 5.96237Z'
    }), jsx("path", {
      d: 'M16.4519 15.5391C16.2164 15.5391 15.9906 15.6326 15.824 15.7991C15.6575 15.9656 15.564 16.1913 15.564 16.4267C15.5645 16.5348 15.5842 16.642 15.6223 16.7431C14.3142 17.7898 12.6887 18.3602 11.0132 18.3607C6.94821 18.3607 3.6418 15.0556 3.6418 10.9924C3.63813 9.42076 4.14054 7.88964 5.07474 6.62547L4.55914 6.24637C3.54257 7.61973 2.99584 9.28401 3.00002 10.9924C3.00002 15.4068 6.59469 19 11.011 19C12.8457 18.9997 14.6247 18.3702 16.0509 17.2165C16.1737 17.2792 16.3097 17.3119 16.4476 17.3118C16.6797 17.3077 16.9009 17.2128 17.0638 17.0475C17.2267 16.8822 17.3183 16.6596 17.3188 16.4276C17.3194 16.1956 17.2289 15.9725 17.0669 15.8064C16.9048 15.6403 16.684 15.5444 16.4519 15.5391ZM16.4519 16.8178C16.3739 16.8178 16.2976 16.7947 16.2328 16.7513C16.1679 16.708 16.1173 16.6464 16.0875 16.5744C16.0576 16.5023 16.0498 16.423 16.065 16.3465C16.0802 16.27 16.1178 16.1998 16.173 16.1446C16.2282 16.0895 16.2984 16.0519 16.375 16.0367C16.4515 16.0215 16.5308 16.0293 16.6029 16.0592C16.675 16.089 16.7366 16.1395 16.7799 16.2044C16.8233 16.2692 16.8464 16.3455 16.8464 16.4235C16.8464 16.528 16.8049 16.6283 16.7309 16.7023C16.6569 16.7762 16.5566 16.8178 16.4519 16.8178Z'
    }), jsx("path", {
      d: 'M11.3741 7.81159H14.3179C14.84 7.81159 15.2885 8.00347 15.6892 8.39589C16.0812 8.78182 16.2688 9.21752 16.2688 9.7304V9.75421C16.2623 10.2718 16.1301 10.6534 15.879 10.8885L15.7772 10.9834L15.8768 11.0826C16.1409 11.3437 16.2753 11.7232 16.2753 12.2126V12.2429C16.2688 12.7583 16.0717 13.2027 15.6754 13.5994C15.2791 13.9961 14.853 14.1866 14.3687 14.1866H10.1807C10.1541 14.1867 10.128 14.1789 10.1058 14.1642C10.0836 14.1495 10.0663 14.1286 10.0561 14.104C10.0459 14.0795 10.0432 14.0526 10.0484 14.0265C10.0537 14.0005 10.0665 13.9766 10.0854 13.9579L11.2168 12.8322C11.2294 12.8198 11.2442 12.81 11.2606 12.8033C11.2769 12.7966 11.2944 12.7932 11.3121 12.7933H14.3082C14.6636 12.7933 14.8672 12.5949 14.8672 12.2476C14.8672 11.8938 14.6679 11.6911 14.3212 11.6911L13.9075 11.6867C13.6691 11.6867 13.4916 11.6287 13.3789 11.5165C13.2597 11.3978 13.2014 11.2081 13.2036 10.9491C13.2036 10.7291 13.2575 10.5654 13.3659 10.4619C13.4742 10.3583 13.6495 10.3046 13.8836 10.3046H13.9031L14.3234 10.3089C14.4922 10.3089 14.6266 10.2613 14.7197 10.1647C14.8193 10.0633 14.8693 9.91218 14.8646 9.71814C14.869 9.56701 14.8284 9.44655 14.7411 9.35746C14.648 9.2626 14.507 9.21319 14.323 9.21319H11.803C11.7848 9.2133 11.7669 9.21699 11.7501 9.22405C11.7334 9.23111 11.7183 9.24139 11.7055 9.25431C11.3331 9.63374 10.5162 10.4536 9.97457 10.9967C9.69525 11.277 9.49382 11.4797 9.446 11.5273C9.33732 11.6395 9.16017 11.6975 8.92396 11.6975C8.68775 11.6975 8.52111 11.6395 8.40409 11.523C8.26099 11.3805 7.90813 11.027 7.35348 10.4748L7.22777 10.3497C7.21923 10.3412 7.20834 10.3354 7.19648 10.333C7.18462 10.3307 7.17233 10.3319 7.16118 10.3366C7.15002 10.3412 7.14051 10.349 7.13385 10.3591C7.12719 10.3691 7.12369 10.3809 7.12379 10.393V13.4898C7.12162 13.9684 6.90643 14.1841 6.42206 14.1884H6.41336C6.17498 14.1884 5.99964 14.1325 5.88915 14.0225C5.77865 13.9125 5.7225 13.7339 5.72467 13.4919V8.50409C5.72467 8.02547 5.93914 7.81195 6.41771 7.81195C6.66044 7.81844 6.84013 7.87651 6.94628 7.98436C7.07851 8.11817 7.68062 8.71545 8.83955 9.8671L8.93483 9.96196L9.03011 9.8671C10.139 8.76306 10.7716 8.13115 10.9103 7.98652C11.023 7.87435 11.1277 7.81195 11.3741 7.81195'
    })]
  }));
});

const PlusIcon = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  return jsx(Icon, Object.assign({
    ref: forwardedRef
  }, props, {
    children: jsx("path", {
      d: 'M11 3C11.7364 3 12.3333 3.59695 12.3333 4.33333V9.66667H17.6667C18.403 9.66667 19 10.2636 19 11C19 11.7364 18.403 12.3333 17.6667 12.3333H12.3333V17.6667C12.3333 18.403 11.7364 19 11 19C10.2636 19 9.66667 18.403 9.66667 17.6667V12.3333H4.33333C3.59695 12.3333 3 11.7364 3 11C3 10.2636 3.59695 9.66667 4.33333 9.66667H9.66667V4.33333C9.66667 3.59695 10.2636 3 11 3Z'
    })
  }));
});

const TrashIcon = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  return jsxs(Icon, Object.assign({
    ref: forwardedRef
  }, props, {
    children: [jsx("path", {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M15.6148 5.52632V4.68421C15.6148 3.75405 14.8719 3 13.9556 3H8.97778C8.06139 3 7.31852 3.75405 7.31852 4.68421V5.52632H4.82963C4.37144 5.52632 4 5.90334 4 6.36842C4 6.8335 4.37144 7.21053 4.82963 7.21053H5.65926V16.4737C5.65926 17.8689 6.77357 19 8.14815 19H14.7852C16.1598 19 17.2741 17.8689 17.2741 16.4737V7.21053H18.1037C18.5619 7.21053 18.9333 6.8335 18.9333 6.36842C18.9333 5.90334 18.5619 5.52632 18.1037 5.52632H15.6148ZM13.9556 4.68421H8.97778V5.52632H13.9556V4.68421ZM15.6148 7.21053H7.31852V16.4737C7.31852 16.9388 7.68996 17.3158 8.14815 17.3158H14.7852C15.2434 17.3158 15.6148 16.9388 15.6148 16.4737V7.21053Z'
    }), jsx("path", {
      d: 'M8.97778 8.89474H10.637V15.6316H8.97778V8.89474Z'
    }), jsx("path", {
      d: 'M12.2963 8.89474H13.9556V15.6316H12.2963V8.89474Z'
    })]
  }));
});

const UpdateIcon = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  return jsxs(Icon, Object.assign({
    ref: forwardedRef
  }, props, {
    children: [jsx("path", {
      d: 'M12.6144 9.30607L17.928 9.90885C18.5452 9.97887 19.0678 9.47655 18.9928 8.88543L18.3485 3.80908C18.252 3.04861 17.2837 2.72856 16.7183 3.27025L12.049 7.74381C11.4826 8.28646 11.819 9.21583 12.6144 9.30607Z'
    }), jsx("path", {
      d: 'M5.29371 5.29625C8.29006 2.42548 13.1481 2.42548 16.1445 5.29625L14.3943 6.97301C12.3646 5.0283 9.07362 5.0283 7.04383 6.97301C6.32128 7.66529 5.85593 8.51067 5.6478 9.40016C5.48907 10.0786 4.9462 10.6655 4.24949 10.6655V10.6655C3.58157 10.6655 3.02442 10.1291 3.12112 9.46817C3.34442 7.9419 4.06862 6.46999 5.29371 5.29625Z'
    }), jsx("path", {
      d: 'M9.38557 12.6939L4.07203 12.0911C3.45481 12.0211 2.93217 12.5234 3.00719 13.1146L3.65147 18.1909C3.74799 18.9514 4.71632 19.2714 5.28171 18.7297L9.95097 14.2562C10.5174 13.7135 10.181 12.7842 9.38557 12.6939Z'
    }), jsx("path", {
      d: 'M16.7063 16.7038C13.7099 19.5745 8.85189 19.5745 5.85554 16.7038L7.60566 15.027C9.63545 16.9717 12.9264 16.9717 14.9562 15.027C15.6787 14.3347 16.1441 13.4893 16.3522 12.5998C16.5109 11.9214 17.0538 11.3345 17.7505 11.3345V11.3345C18.4184 11.3345 18.9756 11.8709 18.8789 12.5318C18.6556 14.0581 17.9314 15.53 16.7063 16.7038Z'
    })]
  }));
});

const PagesIcon = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  return jsxs(Icon, Object.assign({
    ref: forwardedRef
  }, props, {
    children: [jsx("path", {
      "fill-rule": 'evenodd',
      d: 'M15.1538 5H6.84615L6.84615 17H15.1538V5ZM6.84615 3C5.82655 3 5 3.89543 5 5V17C5 18.1046 5.82655 19 6.84615 19H15.1538C16.1734 19 17 18.1046 17 17V5C17 3.89543 16.1734 3 15.1538 3H6.84615Z'
    }), jsx("path", {
      d: 'M19.6154 6.5V15.5H18V17H19.6154C20.3801 17 21 16.3284 21 15.5V6.5C21 5.67157 20.3801 5 19.6154 5H18V6.5H19.6154Z'
    }), jsx("path", {
      d: 'M2.38462 15.5L2.38462 6.5L4 6.5L4 5L2.38462 5C1.61991 5 1 5.67157 1 6.5L1 15.5C1 16.3284 1.61991 17 2.38461 17L4 17L4 15.5L2.38462 15.5Z'
    })]
  }));
});

const LayersIcon = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  return jsx(Icon, Object.assign({
    ref: forwardedRef
  }, props, {
    children: jsx("path", {
      "fill-rule": 'evenodd',
      d: 'M4.30247 8.35103C4.0644 8.19474 3.96687 7.92192 4.00987 7.67015C4.03971 7.4954 4.13724 7.3308 4.30247 7.22232L10.5698 3.10765C10.7884 2.96412 11.0696 2.96412 11.2882 3.10765L17.5555 7.22232C17.6512 7.28509 17.7241 7.36665 17.7744 7.45809C17.9362 7.75238 17.8632 8.14903 17.5555 8.35103L11.2882 12.4657C11.0696 12.6092 10.7884 12.6092 10.5698 12.4657L4.30247 8.35103ZM4.65824 9.5919C4.32434 9.81295 4.14146 10.1603 4.10959 10.5197C4.10817 10.5357 4.10705 10.5517 4.10623 10.5678C4.10029 10.6841 4.1101 10.8011 4.13564 10.915C4.20238 11.2126 4.37658 11.489 4.65824 11.6754L10.3947 15.4731C10.4084 15.4822 10.4223 15.491 10.4363 15.4995C10.5278 15.5549 10.6247 15.5969 10.7244 15.6256C10.9387 15.6873 11.1659 15.6873 11.3801 15.6256C11.4798 15.5969 11.5767 15.5549 11.6683 15.4995C11.6823 15.491 11.6961 15.4822 11.7099 15.4731L17.4463 11.6754C17.728 11.489 17.9022 11.2126 17.9689 10.915C17.998 10.7854 18.0067 10.6517 17.995 10.5197C17.9919 10.4853 17.9875 10.451 17.9817 10.4169C17.9267 10.0949 17.7483 9.79179 17.4463 9.5919L16.3447 10.3397L16.7887 10.6337L11.0523 14.4314L5.31583 10.6337L5.75982 10.3397L4.65824 9.5919ZM11.0523 17.7595L5.31583 13.9618L5.75982 13.6679L4.65824 12.9201C4.37658 13.1065 4.20238 13.3828 4.13564 13.6804C4.12326 13.7356 4.11458 13.7916 4.10959 13.8478C4.07101 14.283 4.25389 14.7359 4.65824 15.0036L10.3947 18.8013C10.4084 18.8104 10.4223 18.8192 10.4363 18.8276C10.8161 19.0575 11.2884 19.0575 11.6683 18.8276C11.6823 18.8192 11.6961 18.8104 11.7099 18.8013L17.4463 15.0036C17.8507 14.7359 18.0335 14.283 17.995 13.8478C17.99 13.7916 17.9813 13.7356 17.9689 13.6804C17.9022 13.3828 17.728 13.1065 17.4463 12.9201L16.3447 13.6679L16.7887 13.9618L11.0523 17.7595ZM7.01561 7.78668L10.929 5.21742L14.8424 7.78668L10.929 10.3559L7.01561 7.78668Z'
    })
  }));
});

const SearchIcon = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  return jsxs(Icon, Object.assign({
    ref: forwardedRef
  }, props, {
    children: [jsx("path", {
      "fill-rule": 'evenodd',
      d: 'M9 12C10.6569 12 12 10.6569 12 9C12 7.34315 10.6569 6 9 6C7.34315 6 6 7.34315 6 9C6 10.6569 7.34315 12 9 12ZM9 14C11.7614 14 14 11.7614 14 9C14 6.23858 11.7614 4 9 4C6.23858 4 4 6.23858 4 9C4 11.7614 6.23858 14 9 14Z'
    }), jsx("path", {
      "fill-rule": 'evenodd',
      d: 'M11.2678 12.2678C11.6248 11.9107 12.2036 11.9107 12.5607 12.2678L17.7322 17.4393C18.0893 17.7964 18.0893 18.3752 17.7322 18.7322C17.3752 19.0893 16.7964 19.0893 16.4393 18.7322L11.2678 13.5607C10.9107 13.2036 10.9107 12.6248 11.2678 12.2678Z'
    })]
  }));
});

const WidgetsIcon = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  return jsxs(Icon, Object.assign({
    ref: forwardedRef
  }, props, {
    children: [jsx("path", {
      fillRule: 'evenodd',
      d: 'M8 10V15H4V10H8Z'
    }), jsx("path", {
      fillRule: 'evenodd',
      d: 'M18 6V15H14V6H18Z'
    }), jsx("path", {
      fillRule: 'evenodd',
      d: 'M13 3V15H9V3H13Z'
    }), jsx("path", {
      fillRule: 'evenodd',
      d: 'M2 18C2 17.4477 2.44772 17 3 17H19C19.5523 17 20 17.4477 20 18C20 18.5523 19.5523 19 19 19H3C2.44772 19 2 18.5523 2 18Z'
    })]
  }));
});

export { AltKeyIcon, ArrowRightIcon, AustriaFlag, BackspaceKeyIcon, CapsKeyIcon, CheckIcon, CloseIcon, CtrlKeyIcon, DownloadIcon, EditIcon, EnterKeyIcon, EscKeyIcon, ExternalIcon, EyeClosedIcon, EyeIcon, GermanyFlag, LayersIcon, MinusIcon, ModBrosIcon, PagesIcon, PlusIcon, SearchIcon, SpaceKeyIcon, TabKeyIcon, TrashIcon, UnitedKingdomFlag, UnitedStatesOfAmericaFlag, UpdateIcon, WidgetsIcon, WindowsKeyIcon };
